export default __webpack_public_path__ + "static/media/user.0068dd20.png";